export default function PlayIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M311.869-268.456v-423.088q0-19.63 13.674-32.565 13.674-12.935 31.827-12.935 5.717 0 12.054 1.62 6.337 1.619 12.054 5.098l333.174 211.782q10.196 6.718 15.413 17.033 5.218 10.315 5.218 21.511t-5.218 21.511q-5.217 10.315-15.413 17.033L381.478-229.674q-5.717 3.479-12.054 5.098-6.337 1.62-12.054 1.62-18.153 0-31.827-12.935-13.674-12.935-13.674-32.565ZM402.87-480Zm0 128.5L604.5-480 402.87-608.5v257Z"
      />
    </svg>
  );
}
